// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  // setPublishTimer()
  // setScroll()
  // ///////////
  if (!_ua.Mobile && !_ua.Tablet) {
    $('#wrapper').addClass('desktop');
  }
  // ///////////
});

$(window).on('load', function () {
  svg4everybody();
  heightLineGroup();
  judgeWinSize();
  setAcc();
  setLoaded();
  setWay();
  setSpan();
  objectFitImages('.ofi-img img');
  // setHeader()
  if ($('#wle-wrapper').hasClass('wle-single')) {
    // setShare()
    setContCurrent();
  } else {
    setModalVideo();
  }
  if (_ua.Mobile || _ua.Tablet || iPadFlag == true) {
    setSpActive();
  }
  if (!_ua.Mobile && !_ua.Tablet && iPadFlag != true) {
  }
});

// モーダルビデオ
var current_scrollY;
function setModalVideo() {
  $('.wle-movieBtn').modalVideo({
    channel: 'youtube',
    youtube: {
      autoplay: 1,
      rel: 0,
      mute: 1,
    },
  });
  $('.wle-movieBtn').on('click', function () {
    current_scrollY = $(window).scrollTop();
    var moveY = -current_scrollY;
    $('body').addClass('setModal');
    $('body').css('top', moveY);
  });
  $('body').on('click', '.modal-video', function () {
    $('body').removeClass('setModal');
    $('html, body').prop({
      scrollTop: current_scrollY,
    });
  });
}

// コンテンツカレント
function setContCurrent() {
  $('.wle-articleStyle_01 a').each(function () {
    if ($(this).hasClass('current')) {
      $(this).parent().addClass('active');
    }
  });
}

// /スマホファーストビュー
function setSpActive() {
  $('.wle-effect-sp').addClass('is-active');
}

// テキストアニメーション用span生成
function setSpan() {
  $('.wle-txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// カルーセル
function setCarousel01() {
  var target = '.wle-carouselStyle_01';
  $(target).each(function () {
    var slider = $(this).find('.wle-screen');
    var slideCount = $(this).find('.wle-screen>.wle-carouselItem').length;
    var baseCount = slideCount + 1;
    if (baseCount > 2) {
      slider.slick({
        // initialSlide: randomStart,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        fade: true,
        speed: 1500,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        // cssEase: 'cubic-bezier(.645, .045, .355, 1)'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });

    var timer = false;
    var currentWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (currentWidth == window.innerWidth) {
        return;
      }
      currentWidth = window.innerWidth;
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        slider.slick('slickPlay');
      }, 200);
    });
  });
}

// gsap
function setWay() {
  $('.wle-effectStyle_01,.wle-effectStyle_02,.js-wle-animation').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '60%',
    }
  );
  $('.js-wle-item-animation').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active-item');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-item-after');
        }, 500);
      }
    },
    {
      offset: '60%',
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.accInfo .ttl').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wle-wrapper').addClass('loaded');
  loadStart();
  // if ($('#wrapper').hasClass('home')) {
  //   loadStart()
  // }else {
  //   $('#wrapper').addClass('loadedDone')
  //   $('#wrapper').addClass('loadEnd')
  // }
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadedDone');
  }, 400);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
  }, 1500);
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// function setGnav () {
//   var i = 0
//   setInterval(function () {
//     $('#headNav li').eq(i).addClass('start')
//     i++
//     if (i >= $('#headNav li').length) i = 0
//   }, 100)
// }

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// /////////////////////////////スムーススクロール
function setScroll() {
  // var headerHight = $('header').height() + 40
  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;

    $.when(
      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      ),
      e.preventDefault()
    ).done(function () {
      var diff = target.offset().top;
      if (diff === position) {
      } else {
        $('html, body').animate(
          {
            scrollTop: diff,
          },
          10,
          'swing'
        );
      }
    });
  });
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup() {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    setAutoHeight('.wle-articleStyle_01 h2');
    setAutoHeight('.wle-articleStyle_01 .wle-update');
    // setAutoHeight('.wle-articleStyle_01 h2', 3);
    // setAutoHeight('.wle-articleStyle_01 .wle-update', 3);
  } else {
    // setAutoHeight('.setH_01 h2', 2)
    // setAutoHeight('.setH_02 h2', 2)
    // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight(target, count) {
  $(target).tile(count);
}

function startResize() {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
